define('views/invite/invitationitem',[
    "backbone",
    "text!views/invite/invitationitem.html",
    "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template  : _.template(Template),
        isRender  : false,
        events    : {},
        initialize: function(options){
            options = options || {};
            this.person = options.person;
            BaseView.prototype.initialize(this);
        },

        loadData: function(){
            this.render();
        },

        render: function(){
            this.name = this.person.firstName + ' ' + this.person.lastName;
            this.acceptedDT = this.person.acceptedDT;
            this.status = (this.acceptedDT) ? 'Accepted' : 'Invited';
            this.date = (this.acceptedDT) ? pf.utcfromnow(this.acceptedDT) : pf.utcfromnow(this.person.invitedDT);

            this.$el.html(this.template());

            return this;
        },

        close: function(){}
    });
});

